import React from 'react';
import Wrapper from './container.style';

type Props = {
	fluid?: boolean;
	className?: string;
	paddingX?: string;
};

const Container: React.FunctionComponent<Props> = ({
	fluid,
	className,
	paddingX,
	children,
}) => {
	const classNames = [];
	if (fluid) {
		classNames.push('fluid');
	}
	if (className) {
		classNames.push(className);
	}
	return (
		<Wrapper className={classNames.join(' ')} fluid={fluid} paddingX={paddingX}>
			{children}
		</Wrapper>
	);
};

export default Container;
